/**
 * Búsqueda de productos: filtro global, teclado, lectora de barras y anti-autocompletado.
 */

function searchState(win) {
	if (!win._posknSearchState) {
		win._posknSearchState = {
			productosVisiblesList: [],
			indiceSeleccionado: -1,
			timer: null,
			lastTerm: '',
		};
	}
	return win._posknSearchState;
}

function getActiveCategory($) {
	const tabCat = $('.category-tab.active').data('category');
	if (tabCat) return tabCat;
	return $('#category-select').val() || null;
}

function resetProductoCardStyles($) {
	$('.producto-card')
		.show()
		.css({
			border: '1px solid #e0e0e0',
			'box-shadow': 'none',
			'background-color': '',
		})
		.removeClass('producto-seleccionado');
}

function escapeSearchHtml(s) {
	return String(s || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function ensureSearchEmptyEl() {
	let el = document.getElementById('poskn-search-empty');
	if (el) return el;
	if (!document.getElementById('poskn-search-empty-css')) {
		const style = document.createElement('style');
		style.id = 'poskn-search-empty-css';
		style.textContent =
			'#poskn-search-empty{display:none;margin:16px 12px;padding:22px 16px;text-align:center;background:#fafafa;border:1px dashed #cfd8dc;border-radius:10px;color:#546e7a;}' +
			'#poskn-search-empty.is-visible{display:block;}' +
			'#poskn-search-empty strong{display:block;color:#1d2327;font-size:15px;}' +
			'#poskn-search-empty p{margin:8px 0 0;font-size:13px;font-weight:400;}';
		document.head.appendChild(style);
	}
	el = document.createElement('div');
	el.id = 'poskn-search-empty';
	el.setAttribute('role', 'status');
	const panel = document.querySelector('.productos-panel');
	const drop = panel ? panel.querySelector('.category-dropdown') : null;
	if (drop && drop.parentNode) {
		drop.parentNode.insertBefore(el, drop.nextSibling);
	} else if (panel) {
		panel.appendChild(el);
	} else {
		document.body.appendChild(el);
	}
	return el;
}

function hideSearchEmpty() {
	const el = document.getElementById('poskn-search-empty');
	if (!el) return;
	el.classList.remove('is-visible');
	el.innerHTML = '';
}

function showSearchEmpty(termino) {
	const el = ensureSearchEmptyEl();
	const q = escapeSearchHtml(String(termino || '').trim());
	el.innerHTML =
		`<strong>No hay productos con ese nombre</strong>` +
		`<p>No se encontró «${q}». Limpia la búsqueda para volver a la categoría.</p>`;
	el.classList.add('is-visible');
}

function disableSearchAutofill($input) {
	$input.attr({
		autocomplete: 'one-time-code',
		autocorrect: 'off',
		autocapitalize: 'off',
		spellcheck: 'false',
		name: 'poskn-buscar-productos-q',
		'data-lpignore': 'true',
		'data-1p-ignore': 'true',
		'data-form-type': 'other',
		enterkeyhint: 'search',
		role: 'searchbox',
	});
	$input.prop('readonly', false);
}

/** Ráfaga típica de lectora HID: dígitos/SKU sin espacios. */
function pareceCodigoBarras(termino) {
	const t = String(termino || '').trim();
	if (t.length < 4) return false;
	if (/\s/.test(t)) return false;
	if (/^[0-9]{6,}$/.test(t)) return true;
	return t.length >= 8 && /^[A-Za-z0-9._-]+$/.test(t);
}

function normalizeSku(s) {
	return String(s || '')
		.trim()
		.toLowerCase()
		.replace(/[\s\u200b\u00a0\r\n\t]/g, '');
}

function skuDeElemento(el, win) {
	if (!el) return '';
	const attr = normalizeSku(el.getAttribute('data-product-sku'));
	if (attr) return attr;
	const textEl = el.querySelector('.producto-sku');
	const text = textEl ? normalizeSku(String(textEl.textContent || '').replace(/^\s*SKU:\s*/i, '')) : '';
	if (text) return text;
	const pid = parseInt(el.getAttribute('data-product-id') || '0', 10);
	if (pid && typeof win.posknFindProductoEnData === 'function') {
		const p = win.posknFindProductoEnData(pid);
		if (p) return normalizeSku(p.sku);
	}
	return '';
}

function findProductoPorSku(win, termino) {
	const t = normalizeSku(termino);
	if (!t || !Array.isArray(win.productosData)) return null;
	for (let i = 0; i < win.productosData.length; i++) {
		const products = win.productosData[i] && win.productosData[i].products;
		if (!Array.isArray(products)) continue;
		for (let j = 0; j < products.length; j++) {
			const p = products[j];
			if (!p) continue;
			if (normalizeSku(p.sku) === t) {
				return p;
			}
			if (!Array.isArray(p.variations)) continue;
			for (let k = 0; k < p.variations.length; k++) {
				const v = p.variations[k];
				if (v && normalizeSku(v.sku) === t) {
					return Object.assign({}, p, { scanned_variation_id: v.id });
				}
			}
		}
	}
	return null;
}

function cardPorProductoId(productId) {
	const pid = parseInt(productId || 0, 10);
	if (!pid) return null;
	return document.querySelector(`.producto-card[data-product-id="${pid}"]`);
}

function cancelarBusquedaProgramada(win) {
	const state = searchState(win);
	if (state.timer) {
		win.clearTimeout(state.timer);
		state.timer = null;
	}
}

function productoDesdeCard(win, $card) {
	const el = $card && $card[0] ? $card[0] : null;
	if (!el) return null;
	const pid = parseInt(el.getAttribute('data-product-id') || '0', 10);
	if (pid && typeof win.posknFindProductoEnData === 'function') {
		const fromData = win.posknFindProductoEnData(pid);
		if (fromData) return fromData;
	}
	if (pid && Array.isArray(win.productosData)) {
		for (let i = 0; i < win.productosData.length; i++) {
			const products = win.productosData[i] && win.productosData[i].products;
			if (!Array.isArray(products)) continue;
			for (let j = 0; j < products.length; j++) {
				if (products[j] && parseInt(products[j].id, 10) === pid) {
					return products[j];
				}
			}
		}
	}
	const onclickAttr = $card.attr('onclick') || '';
	const match = onclickAttr.match(/abrirModalProducto\((.+)\)/);
	if (!match) return null;
	try {
		return JSON.parse(match[1]);
	} catch (e) {
		return null;
	}
}

function modalProductoAbierto($) {
	const $modal = $('#modal-producto');
	if (!$modal.length) return false;
	const display = $modal.css('display');
	return display === 'flex' || display === 'block' || $modal.hasClass('show');
}

function abrirProductoDirecto(win, $, producto) {
	if (!producto || typeof win.abrirModalProducto !== 'function') {
		return false;
	}
	if (modalProductoAbierto($)) {
		return true;
	}
	win.abrirModalProducto(producto);
	if (producto.scanned_variation_id) {
		win.setTimeout(() => {
			const sel = win.document.getElementById('modal-variacion-select');
			if (sel) {
				sel.value = String(producto.scanned_variation_id);
				sel.dispatchEvent(new Event('change'));
			}
		}, 0);
	}
	$('#buscar-productos').val('');
	return true;
}

function abrirProductoSeleccionado(win, $) {
	const state = searchState(win);
	if (
		state.indiceSeleccionado < 0 ||
		state.indiceSeleccionado >= state.productosVisiblesList.length
	) {
		return false;
	}
	const $card = state.productosVisiblesList[state.indiceSeleccionado];
	const productoData = productoDesdeCard(win, $card);
	if (productoData) {
		return abrirProductoDirecto(win, $, productoData);
	}
	return false;
}

function productosDeRespuestaBusqueda(res) {
	if (!res) return [];
	const data = res.data != null ? res.data : res;
	if (Array.isArray(data)) return data;
	if (data && Array.isArray(data.products)) return data.products;
	if (res.success && res.data && Array.isArray(res.data.products)) return res.data.products;
	return [];
}

function aplicarEscaneo(win, $, termino) {
	const code = String(termino || '').trim();
	if (!code) return false;
	win.realizarBusqueda(code);
	const state = searchState(win);
	if (state.indiceSeleccionado >= 0 && state.productosVisiblesList.length) {
		return abrirProductoSeleccionado(win, $);
	}
	const fromData = findProductoPorSku(win, code);
	if (fromData) {
		return abrirProductoDirecto(win, $, fromData);
	}
	if (
		pareceCodigoBarras(code) &&
		win.POSKN &&
		win.POSKN.api &&
		typeof win.POSKN.api.searchProducts === 'function'
	) {
		const req = win.POSKN.api.searchProducts(code, 8, 8000);
		const done = (res) => {
			if (normalizeSku($('#buscar-productos').val()) !== normalizeSku(code)) {
				return;
			}
			const items = productosDeRespuestaBusqueda(res);
			let hit = null;
			for (let i = 0; i < items.length; i++) {
				const row = items[i];
				if (!row) continue;
				if (normalizeSku(row.sku) === normalizeSku(code)) {
					hit = row;
					break;
				}
				if (Array.isArray(row.variations)) {
					for (let v = 0; v < row.variations.length; v++) {
						if (row.variations[v] && normalizeSku(row.variations[v].sku) === normalizeSku(code)) {
							hit = Object.assign({}, row, { scanned_variation_id: row.variations[v].id });
							break;
						}
					}
				}
				if (hit) break;
			}
			if (!hit && items.length === 1) {
				hit = items[0];
			}
			if (hit) {
				const local = findProductoPorSku(win, code) || (hit.id && typeof win.posknFindProductoEnData === 'function' ? win.posknFindProductoEnData(hit.id) : null);
				abrirProductoDirecto(win, $, local || hit);
				return;
			}
			if (typeof win.mostrarNotificacion === 'function') {
				win.mostrarNotificacion('No hay producto con el código ' + code, 'error');
			}
		};
		if (req && typeof req.done === 'function') {
			req.done(done).fail(() => {});
		} else if (req && typeof req.then === 'function') {
			req.then(done).catch(() => {});
		}
	} else if (typeof win.mostrarNotificacion === 'function') {
		win.mostrarNotificacion('No hay producto con el código ' + code, 'error');
	}
	return false;
}

function programarBusqueda(win, $, termino) {
	const state = searchState(win);
	cancelarBusquedaProgramada(win);
	const delay = pareceCodigoBarras(termino) ? 80 : 140;
	state.timer = win.setTimeout(() => {
		state.timer = null;
		if (pareceCodigoBarras(termino)) {
			aplicarEscaneo(win, $, termino);
			return;
		}
		win.realizarBusqueda(termino);
	}, delay);
}

function initProductsSearchEvents(win, $) {
	if (win._posknProductsSearchBound) return;
	win._posknProductsSearchBound = true;

	// Delegación: el bundle carga en <head> antes de que exista #buscar-productos
	$(document).on('input', '#buscar-productos', function onSearchInput() {
		programarBusqueda(win, $, $(this).val());
	});

	$(document).on('keydown', '#buscar-productos', function onSearchKeydown(e) {
		const state = searchState(win);

		if (e.key === 'Escape') {
			e.preventDefault();
			cancelarBusquedaProgramada(win);
			win.limpiarBusquedaProductos(true);
			return;
		}

		if (e.key === 'Enter') {
			e.preventDefault();
			cancelarBusquedaProgramada(win);
			const termino = String($(this).val() || '').trim();
			if (!termino) {
				return;
			}
			if (pareceCodigoBarras(termino)) {
				aplicarEscaneo(win, $, termino);
				return;
			}
			win.realizarBusqueda(termino);
			if (state.indiceSeleccionado >= 0 && state.productosVisiblesList.length) {
				abrirProductoSeleccionado(win, $);
			}
			return;
		}

		if (!state.productosVisiblesList.length) return;

		if (e.key === 'ArrowDown') {
			e.preventDefault();
			if (state.indiceSeleccionado < state.productosVisiblesList.length - 1) {
				if (state.indiceSeleccionado >= 0) {
					state.productosVisiblesList[state.indiceSeleccionado]
						.css({
							border: '1px solid #e0e0e0',
							'box-shadow': 'none',
							'background-color': '',
						})
						.removeClass('producto-seleccionado');
				}
				state.indiceSeleccionado += 1;
				win.resaltarProductoSeleccionado();
			}
		} else if (e.key === 'ArrowUp') {
			e.preventDefault();
			if (state.indiceSeleccionado > 0) {
				if (state.indiceSeleccionado >= 0) {
					state.productosVisiblesList[state.indiceSeleccionado]
						.css({
							border: '1px solid #e0e0e0',
							'box-shadow': 'none',
							'background-color': '',
						})
						.removeClass('producto-seleccionado');
				}
				state.indiceSeleccionado -= 1;
				win.resaltarProductoSeleccionado();
			}
		}
	});

	$(document).on('click', '#limpiar-busqueda', () => {
		cancelarBusquedaProgramada(win);
		win.limpiarBusquedaProductos(true);
	});

	$(document).on('click', '.producto-card', (e) => {
		if (!e.originalEvent) return;
		win.setTimeout(() => {
			win.limpiarBusquedaProductos(true);
		}, 500);
	});

	$(() => {
		const $input = $('#buscar-productos');
		if ($input.length) {
			disableSearchAutofill($input);
		}
		win.setTimeout(() => {
			$('#buscar-productos').focus();
		}, 300);
	});
}

export function attachProductsSearchGlobals(win, $) {
	initProductsSearchEvents(win, $);

	win.posknResetBusquedaIndices = function posknResetBusquedaIndices() {
		const state = searchState(win);
		state.productosVisiblesList.length = 0;
		state.indiceSeleccionado = -1;
	};
	win.posknHideSearchEmpty = hideSearchEmpty;

	win.mostrarSoloCategoria = function mostrarSoloCategoria(categoria) {
		hideSearchEmpty();
		if (!categoria) {
			$('.productos-container').addClass('active').css('display', 'flex');
			$('.producto-card').css('display', 'flex');
			return;
		}
		$('.productos-container').removeClass('active').hide();
		$(`.productos-container[data-category="${categoria}"]`).addClass('active').css('display', 'flex');
	};

	win.limpiarBusquedaProductos = function limpiarBusquedaProductos(focus, categoriaOverride) {
		cancelarBusquedaProgramada(win);
		hideSearchEmpty();
		$('#buscar-productos').val('');
		win.posknResetBusquedaIndices();
		resetProductoCardStyles($);

		const cat =
			categoriaOverride != null && categoriaOverride !== ''
				? categoriaOverride
				: getActiveCategory($);
		if (cat && typeof win.posknInitPagination === 'function') {
			win.setTimeout(() => win.posknInitPagination(cat), 100);
		}
		win.mostrarSoloCategoria(cat);

		if (focus) {
			$('#buscar-productos').focus();
		}
	};

	win.posknAplicarCodigoBarras = function posknAplicarCodigoBarras(codigo) {
		const code = String(codigo || '').trim();
		if (!code) {
			return false;
		}
		cancelarBusquedaProgramada(win);
		$('#buscar-productos').val(code);
		return aplicarEscaneo(win, $, code);
	};

	win.realizarBusqueda = function realizarBusqueda(termino) {
		const state = searchState(win);
		termino = String(termino || '').trim();
		state.lastTerm = termino;

		$('.producto-card')
			.css({
				border: '1px solid #e0e0e0',
				'box-shadow': 'none',
				'background-color': '',
			})
			.removeClass('producto-seleccionado');
		state.productosVisiblesList.length = 0;
		state.indiceSeleccionado = -1;

		if (!termino) {
			hideSearchEmpty();
			win.mostrarSoloCategoria(getActiveCategory($));
			const cat = $('#category-select').val();
			if (cat && typeof win.posknInitPagination === 'function') {
				win.setTimeout(() => win.posknInitPagination(cat), 100);
			}
			return;
		}

		$('.productos-pagination').hide();

		const terminoLower = termino.toLowerCase();
		const terminoSku = normalizeSku(termino);
		const fromData = findProductoPorSku(win, termino);
		const cards = document.querySelectorAll('.producto-card');
		const matches = [];
		let exactEl = cardPorProductoId(fromData && fromData.id);

		for (let i = 0; i < cards.length; i++) {
			const el = cards[i];
			const sku = skuDeElemento(el, win);
			const nombre = (el.getAttribute('data-product-name') || '').toLowerCase();
			let coincide = false;
			if (sku && sku === terminoSku) {
				coincide = true;
				exactEl = el;
			} else if (nombre.indexOf(terminoLower) !== -1) {
				coincide = true;
			} else if (sku && sku.indexOf(terminoSku) !== -1) {
				coincide = true;
			} else if (fromData && parseInt(el.getAttribute('data-product-id') || '0', 10) === parseInt(fromData.id, 10)) {
				coincide = true;
				exactEl = exactEl || el;
			}
			if (coincide) {
				matches.push(el);
			}
		}

		if (!exactEl && fromData) {
			exactEl = cardPorProductoId(fromData.id);
			if (exactEl && matches.indexOf(exactEl) === -1) {
				matches.unshift(exactEl);
			}
		}

		const mostrar = exactEl ? [exactEl] : matches;

		if (!mostrar.length) {
			$('.producto-card').hide();
			$('.productos-container').removeClass('active').hide();
			$('.productos-pagination').hide();
			showSearchEmpty(termino);
			return;
		}

		hideSearchEmpty();
		$('.producto-card').hide();
		$('.productos-container').removeClass('active').hide();

		const seenContainers = new Set();
		mostrar.forEach((el) => {
			el.style.display = 'flex';
			const container = el.closest('.productos-container');
			if (container && !seenContainers.has(container)) {
				container.classList.add('active');
				container.style.display = 'flex';
				seenContainers.add(container);
			}
			state.productosVisiblesList.push($(el));
		});

		if (exactEl) {
			const $card = $(exactEl);
			$card.css({
				border: '2px solid #4CAF50',
				'box-shadow': '0 0 10px rgba(76, 175, 80, 0.3)',
			});
			state.indiceSeleccionado = 0;
			win.resaltarProductoSeleccionado(true);
		} else if (state.productosVisiblesList.length) {
			state.indiceSeleccionado = 0;
			win.resaltarProductoSeleccionado(true);
		}
	};

	win.resaltarProductoSeleccionado = function resaltarProductoSeleccionado(instant) {
		const state = searchState(win);
		if (
			state.indiceSeleccionado < 0 ||
			state.indiceSeleccionado >= state.productosVisiblesList.length
		) {
			return;
		}
		const $card = state.productosVisiblesList[state.indiceSeleccionado];
		$card
			.css({
				border: '3px solid #2196F3',
				'box-shadow': '0 0 15px rgba(33, 150, 243, 0.5)',
				'background-color': '#E3F2FD',
			})
			.addClass('producto-seleccionado');

		const elemento = $card[0];
		if (elemento) {
			elemento.scrollIntoView({
				behavior: instant ? 'auto' : 'smooth',
				block: instant ? 'nearest' : 'center',
			});
		}
	};

	win.seleccionarProductoActual = function seleccionarProductoActual() {
		return abrirProductoSeleccionado(win, $);
	};
}
